import { Link } from "react-router-dom";
import '../../styles/Custom-Button.css';

export default function CustomButton({ route, text }) {

    return (
        <div className="btn-wrapper">
            <Link to={route}>
                <button className="custom-btn">{text}</button>
            </Link>
        </div>
    )

}